/**
 * CampaignInfoRemapper
 *
 * Parses Firestore wire JSON into a `CampaignInfoDto`.
 * Flutter source: lib/data/models/campaign_info.dart (no @JsonKey — Dart property == Firestore field).
 */
import type { CampaignInfoDto } from '@/data/dtos/info/campaignInfoDto';
import type { JsonObject } from '@/data/types/json';

export class CampaignInfoRemapper {
  static fromJson(data: JsonObject): CampaignInfoDto {
    return {
      campaignId: (data['campaignId'] as string | undefined) ?? '',
      campaignTitle: (data['campaignTitle'] as string | undefined) ?? '',
      ranking: (data['ranking'] as number | undefined) ?? 0,
    };
  }

  static fromJsonList(dataList: JsonObject[]): CampaignInfoDto[] {
    return dataList.map(CampaignInfoRemapper.fromJson);
  }
}
